import type { ReactNode } from "react";

import { useEditModeMaybe } from "../use-edit-mode-maybe";

export function LinksSectionGate({
  hasContent,
  children,
}: {
  hasContent: boolean;
  children: ReactNode;
}) {
  const mode = useEditModeMaybe();

  if (!hasContent && !mode?.editing) return null;

  return <>{children}</>;
}
